export const normalizeImageUrl = (imageUrl: string) =>
  new URL(imageUrl, import.meta.url).href;
